import { useMemo } from 'react';
import { useInfiniteQuery } from 'react-query';
import * as api from '../../services/api';

export const HELP_DESK_MESSAGES_QUERY_KEY = 'helpDeskMessages';
const PAGE_SIZE = 50;

export const getHelpDeskMessagesQueryKey = (accountId, ticketId) => [
  HELP_DESK_MESSAGES_QUERY_KEY,
  accountId ?? null,
  ticketId !== undefined ? Number(ticketId) : null
];

const useHelpDeskMessages = ({ accountId, ticketId, enabled = true }) => {
  const queryKey = getHelpDeskMessagesQueryKey(accountId, ticketId);

  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery(
    queryKey,
    ({ pageParam = 0 }) => api.fetchHelpDeskMessages({ accountId, ticketId, limit: PAGE_SIZE, offset: pageParam }),
    {
      enabled: !!accountId && !!ticketId && enabled,
      getNextPageParam: (lastPage, allPages) => {
        const totalFetched = allPages.reduce((sum, page) => sum + (page.data?.length ?? 0), 0);
        return totalFetched < (lastPage.total ?? 0) ? totalFetched : undefined;
      }
    }
  );

  const messages = useMemo(() => (data?.pages ?? []).flatMap((page) => page.data ?? []), [data?.pages]);
  const total = data?.pages?.[0]?.total ?? messages.length;

  return { messages, total, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage };
};

export default useHelpDeskMessages;
